export default __webpack_public_path__ + "static/heroBg-3da94f257cdccd70b885fa4e4c393ecd.png";